module.exports = __webpack_public_path__ + "static/vf_wsneakers_core.11fda945.svg";